"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFileType = exports.onConvertFileType = exports.confirmValidateExtensions = void 0;
var _messageBox = _interopRequireDefault(require("element-ui/packages/message-box"));
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _fileType = require("./file-type");
var _mimeType = require("./mime-type");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const confirmValidateExtensions = (file, acceptedFileTypes, allowConvertFileType) => {
  try {
    return _messageBox.default.confirm(`<div>
           <div>B\u1EA1n \u0111ang upload \u1EA3nh c\xF3 \u0111\u1ECBnh d\u1EA1ng  ${(0, _fileType.getExtensionFromFilename)(file.name)}</div>
           <div>B\u1EA1n c\u1EA7n upload nh\u1EEFng \u1EA3nh c\xF3 \u0111\u1ECBnh d\u1EA1ng nh\u01B0: ${acceptedFileTypes.join(", ")}</div>
      </div>`, "C\u1EA3nh b\xE1o", {
      showConfirmButton: allowConvertFileType,
      confirmButtonText: "Auto convert",
      cancelButtonText: "Upload l\u1EA1i",
      type: "warning",
      dangerouslyUseHTMLString: true
    });
  } catch {
    return false;
  }
};
exports.confirmValidateExtensions = confirmValidateExtensions;
const onConvertFileType = async (file, type) => {
  return await (0, _browserImageCompression.default)(file, {
    fileType: type
  });
};
exports.onConvertFileType = onConvertFileType;
const validateFileType = async (file, {
  allowFileTypeValidation,
  allowConvertFileType,
  acceptedFileTypes,
  callbackConvertFileType
}) => {
  if (!allowFileTypeValidation) return true;
  if (acceptedFileTypes.length === 0) return true;
  const fileType = (0, _fileType.getFileType)(file);
  const isValid = (0, _mimeType.isValidMimeType)(acceptedFileTypes, fileType);
  if (!isValid) {
    const isConfirm = await confirmValidateExtensions(file, acceptedFileTypes, allowConvertFileType);
    if (!isConfirm || !callbackConvertFileType) {
      throw "INVALID_FILE_TYPE";
    } else {
      await callbackConvertFileType();
      return true;
    }
  }
  return true;
};
exports.validateFileType = validateFileType;